module.exports = __webpack_public_path__ + "static/media/CancelBlack.b2a620ad.svg";